import {
  WelcomeWizard,
  type WelcomeWizardGroup,
} from "@/components/onboarding/components/WelcomeWizard";
import { InterstitialOverlay } from "@/components/overlay/InterstitialOverlay";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

interface WelcomeOverlayProps {}

export const WelcomeOverlay = observer<WelcomeOverlayProps>(() => {
  const { store } = useAppStore();
  const onboardingInfo = store.platformInfo.onboardingInfo;
  const isOpen = onboardingInfo.shouldShowWelcomeOverlay;
  const initialStep = onboardingInfo.welcomeInitialStep;
  const stepGroups = onboardingInfo.welcomeStepGroups;
  useTrackView(isOpen);

  const handleDismiss = (group: WelcomeWizardGroup, ...rest: string[]) => {
    switch (group) {
      case "icp-rfi":
        store.platformInfo.onboardingInfo.markStepCompleted("user-profile");
        store.platformInfo.dismissIcpRfi({ completedSteps: rest });
        break;
      case "import-cta":
      case "post-import":
        store.platformInfo.dismissImportCta();
        break;
    }
  };

  return (
    <InterstitialOverlay isOpen={isOpen}>
      <WelcomeWizard
        isOpen={isOpen}
        initialStep={initialStep}
        stepGroups={stepGroups}
        onClose={handleDismiss}
        onSkip={handleDismiss}
      />
    </InterstitialOverlay>
  );
});

const useTrackView = (isOpen: boolean) => {
  const didTrack = useRef(false);
  useEffect(() => {
    if (didTrack.current || !isOpen) return;
    trackEvent(TrackedEvent.WelcomeOverlayView);
    didTrack.current = true;
  }, [isOpen]);
};
